import { defineStore } from 'pinia'

export const useProcessoIncidenteStore = defineStore('processosincidente', {
  state: () => ({
    processos: [],

    classe: 0,
    numero: 0
  }),
  getters: {
    all: state => state.processos,
  },
  actions: {
    save() {
      this.processos.push({
        classe: this.classe,
        numero: this.numero,
      })
      this.clear()
    },
    clear() {
      this.classe = 0,
      this.numero = 0
    }
  },
})
